module.exports = "//public.getcloudapp.com/packs/media/images/annotate/emoji@2x-acbf90dbc046c92e1efa9d82b7450659.png";